<nav class="ss-navbar">
  <a class="ss-nav-brand" href="#">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
      <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z"/>
    </svg>
    SafeScan
  </a>

  <span class="ss-nav-spacer"></span>

  <ng-container *ngIf="isLoggedIn">
    <span class="ss-nav-meta" *ngIf="storeName">{{ storeName }}</span>

    <div class="ss-nav-actions">
      <div class="ss-nav-dropdown">
        <button class="ss-nav-btn" (click)="dropdownOpen = !dropdownOpen">
          Actions
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" viewBox="0 0 16 16" style="margin-left:3px">
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg>
        </button>
        <div class="ss-dropdown-menu" *ngIf="dropdownOpen">
          <a class="ss-dropdown-item" *ngIf="userRole === 'Admin'" routerLink="/store" (click)="dropdownOpen = false">Manage Stores</a>
          <a class="ss-dropdown-item" *ngIf="userRole === 'StoreAdmin'" routerLink="/user" (click)="dropdownOpen = false">Manage Users</a>
          <hr class="ss-dropdown-divider">
          <a class="ss-dropdown-item" routerLink="/batchlist" (click)="dropdownOpen = false">Manage Batches</a>
          <a class="ss-dropdown-item" routerLink="/dashboard" (click)="dropdownOpen = false">Dashboard</a>
        </div>
      </div>

      <button class="ss-nav-btn" (click)="logout()">Logout</button>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoggedIn && showLoginButton">
    <a class="ss-nav-login" routerLink="/login">Login</a>
  </ng-container>
</nav>
